export default __webpack_public_path__ + "static/media/bg05.1726dcf1.png";